import React, { useContext } from 'react';
import TranslationsContext from 'translations/TranslationsContext';

interface IStatusColumnProps {
    status: string;
}

const StatusColumn = ({ status }: IStatusColumnProps) => {
	const { t } = useContext(TranslationsContext)!;

	return (
		<span>{t(`CheckResult.Status.${status}`)}</span>
	);
};

export default StatusColumn;
